import PropTypes from 'prop-types'
import React, { Component } from 'react'
import classNames from 'classnames'

import { CaretBottomIcon } from 'components/Utils/Icons'

const SIZES = {
  small: 30,
  normal: 40,
  large: 50,
}

class Select extends Component {
  static propTypes = {
    size: PropTypes.oneOf(['small', 'normal', 'large']).isRequired,
    fullWidth: PropTypes.bool,
  }

  static defaultProps = {
    size: 'normal',
  }

  render() {
    const { children, className, size, fullWidth, ...props } = this.props
    return (
      <div
        className={classNames('position-relative background-shade-100', {
          'width-full': fullWidth,
        })}
      >
        <select
          className={classNames(
            [
              'position-relative zindex-small',
              'pointer center-text',
              'background-transparent',
              'border-solid border-shade-30 border-shade-20-on-hover',
              'shade-10 shadow-bottom--small',
              'font-weight-large shade-10 font-size-small',
              'radius-normal',
              'border-small',
              'padding-horizontal-normal padding-right-large',
            ],
            { 'width-full': fullWidth },
            className
          )}
          style={{
            height: SIZES[size],
            lineHeight: `${SIZES[size]}px`,
            paddingRight: `${SIZES[size]}px`,
          }}
          {...props}
        >
          {children}
        </select>
        <div
          className="position-absolute zindex-null flexbox flexbox-centered"
          style={{ height: SIZES[size], width: SIZES[size], top: 0, right: 0 }}
        >
          <CaretBottomIcon className="shade-30" size={12} />
        </div>
      </div>
    )
  }
}

export default Select
